import { supabase } from "@/integrations/supabase/client";

// Only the membership id and the private token from the email are sent:
// the amount is read from the saved membership on the server.
interface PaymentData {
  membershipId: string;
  token: string;
}

// Créer une session de paiement Stripe via la fonction Edge
export async function createStripePayment(paymentData: PaymentData) {
  const { data, error } = await supabase.functions.invoke("create-stripe-payment", {
    body: paymentData,
  });

  if (error) {
    throw new Error("Erreur lors de la création de la session de paiement");
  }
  if (!data || data.error) {
    throw new Error("Aucune donnée de session n'a été renvoyée");
  }

  if (data.sessionId) {
    localStorage.setItem("stripe_session_id", data.sessionId);
  }

  return {
    sessionId: data.sessionId as string | undefined,
    sessionUrl: data.sessionUrl as string | undefined,
  };
}

/** Asks the server to check a Stripe checkout and record the payment. */
export async function confirmCheckout(sessionId: string): Promise<{ status: string; type?: string; id?: string }> {
  const { data, error } = await supabase.functions.invoke("confirm-checkout", { body: { sessionId } });
  if (error || !data) return { status: "error" };
  return data as { status: string; type?: string; id?: string };
}
